module.exports = __webpack_public_path__ + "static/media/Crowding of teeth on both jaws1.90924fdb.png";